import React from 'react';
import PropTypes from 'prop-types';
import {
	Route, Switch, Redirect, ReportDashboardContainer,
	OpportunityListContainer, SuccessListContainer, FailureListContainer,
	OptOutListContainer
} from 'gwx-voyager-components';

const Reports = ({ match }) => (
	<div>
		<ReportDashboardContainer source='Client Admin' communityId={match.params.id} />
		<Switch>
			<Route exact path={match.path} />
			<Route path={`${match.path}/opportunity`} render={(props) => <OpportunityListContainer {...props} source='Client Admin' />} />
			<Route path={`${match.path}/success`} render={(props) => <SuccessListContainer {...props} source='Client Admin' />} />
			<Route path={`${match.path}/failure`} render={(props) => <FailureListContainer {...props} source='Client Admin' />} />
			<Route path={`${match.path}/optedOut`} render={(props) => <OptOutListContainer {...props} source='Client Admin' />} />
			<Redirect to='/pageNotFound' />
		</Switch>
	</div>
);
Reports.propTypes = {
	match: PropTypes.shape({
		path: PropTypes.string.isRequired,
		params: PropTypes.shape({
			id: PropTypes.string
		})
	}).isRequired
};

export default Reports;
